<div class="modal-content-with-padding">
    <nts-labelled-text-box [propertyViewModel]="viewModel.name">
    </nts-labelled-text-box>
</div>
